export default {
  computed: {
    browserLanguage() {
      return this.getBrowserLanguage(window.navigator.language);
    },
    browserCountry() {
      const parts = this.browserLanguage.split('-');
      let c = parts[0];

      if (parts.length === 2) {
        c = parts[1];
      }

      return c;
    },
    browserSimpleLanguage() {
      return this.getBrowserSimpleLanguage(this.browserLanguage);
    },
    theCurrentLanguage() {
      if (localStorage.getItem('language')) {
        return localStorage.getItem('language');
      }

      return this.getBrowserSimpleLanguage(this.browserLanguage);
    },
    browserSimpleCountry() {
      return this.getBrowserSimpleCountry(this.browserCountry);
    },
    theCurrentCountry() {
      if (localStorage.getItem('country')) {
        return localStorage.getItem('country');
      }

      const lang = this.theCurrentLanguage;
      console.log(lang);

      const bLang = this.getBrowserLanguage(lang);
      console.log(bLang);

      const country = this.getBrowserSimpleCountry(bLang);
      console.log(country);

      if (['DK', 'FI', 'NO', 'SE'] !== -1) {
        return country;
      }

      return 'other';
    },
  },
  methods: {
    getBrowserSimpleLanguage(input) {
      const parts = input.split('-');
      let c = parts[0];

      if (parts.length === 2) {
        c = parts[0];
      }

      return c;
    },
    getBrowserSimpleCountry(input) {
      const parts = input.split('-');
      let c = parts[0];

      if (parts.length === 2) {
        c = parts[1];
      }

      return c;
    },
    getBrowserLanguage(input) {
      const language = input;

      if (language.indexOf('-') !== -1) {
        return language;
      }

      // todo
      if (language === 'sv') {
        return 'sv-SE';
      }

      if (language === 'da') {
        return 'da-DK';
      }

      if (language === 'fi') {
        return 'fi-FI';
      }

      if (language === 'no') {
        return 'nb-NO';
      }

      return 'en-GB';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/languageDetector.js